function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var i = Object.defineProperty;
var l = Object.getOwnPropertySymbols;
var r = Object.prototype.hasOwnProperty,
    d = Object.prototype.propertyIsEnumerable;

var o = function o(e, C, L) {
  return C in e ? i(e, C, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: L
  }) : e[C] = L;
},
    t = function t(e, C) {
  for (var L in C || (C = {})) {
    r.call(C, L) && o(e, L, C[L]);
  }

  if (l) {
    var _iterator = _createForOfIteratorHelper(l(C)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var L = _step.value;
        d.call(C, L) && o(e, L, C[L]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return e;
};

import * as n from "react";

function v(e) {
  return n.createElement("svg", t({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), n.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2499 12C18.2499 12.2833 18.2249 12.55 18.1915 12.8167L19.9499 14.1917C20.1082 14.3167 20.1499 14.5417 20.0499 14.725L18.3832 17.6083C18.2832 17.7917 18.0665 17.8667 17.8749 17.7917L15.7999 16.9583C15.3665 17.2833 14.8999 17.5667 14.3915 17.775L14.0749 19.9833C14.0499 20.1833 13.8749 20.3333 13.6665 20.3333H10.3332C10.1249 20.3333 9.94987 20.1833 9.92487 19.9833L9.6082 17.775C9.09987 17.5667 8.6332 17.2917 8.19987 16.9583L6.12487 17.7917C5.94153 17.8583 5.71653 17.7917 5.61653 17.6083L3.94987 14.725C3.84987 14.5417 3.89153 14.3167 4.04987 14.1917L5.8082 12.8167C5.77487 12.55 5.74987 12.275 5.74987 12C5.74987 11.725 5.77487 11.45 5.8082 11.1833L4.04987 9.80833C3.89153 9.68333 3.84153 9.45833 3.94987 9.275L5.61653 6.39167C5.71653 6.20833 5.9332 6.13333 6.12487 6.20833L8.19987 7.04167C8.6332 6.71667 9.09987 6.43333 9.6082 6.225L9.92487 4.01667C9.94987 3.81667 10.1249 3.66667 10.3332 3.66667H13.6665C13.8749 3.66667 14.0499 3.81667 14.0749 4.01667L14.3915 6.225C14.8999 6.43333 15.3665 6.70833 15.7999 7.04167L17.8749 6.20833C18.0582 6.14167 18.2832 6.20833 18.3832 6.39167L20.0499 9.275C20.1499 9.45833 20.1082 9.68333 19.9499 9.80833L18.1915 11.1833C18.2249 11.45 18.2499 11.7167 18.2499 12ZM9.0832 12C9.0832 13.6083 10.3915 14.9167 11.9999 14.9167C13.6082 14.9167 14.9165 13.6083 14.9165 12C14.9165 10.3917 13.6082 9.08333 11.9999 9.08333C10.3915 9.08333 9.0832 10.3917 9.0832 12Z",
    fill: "black"
  }));
}

export { v as ReactComponent };